
<div style="font-size: 13px">
    <v-row class="no-frame">
        <v-col class="no-frame col-12 contract-info" v-if="isFrequency">
            <span class="secondary--text" >Zahlung</span>
            <span class="ml-1" style="font-weight: 600">{{ frequency }}</span>
            <span class="secondary--text ml-1" v-if="deadline" v-html="deadline"></span>
        </v-col>
        <v-col class="no-frame col-12 contract-info" v-if="!isFrequency">
            <span class="secondary--text" >Zahlung</span>
            <span class="ml-1" style="font-weight: 600">nicht festgelegt</span>
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame col-12 contract-info" v-if="isToc">
            <span class="secondary--text">Kündigungsfrist</span>
            <span class="ml-1 secondary--text">{{ toc }}</span>
        </v-col>
        <v-col class="no-frame col-12 contract-info" v-if="!isToc">
            <span class="secondary--text">Kündigungsfrist</span>
            <span class="ml-1" style="font-weight: 600">nicht festgelegt</span>
        </v-col>
    </v-row>
</div>
